import { Box, Icon, Text } from '@chakra-ui/react';
import { LuMonitorX } from 'react-icons/lu';

const ErrorView = () => {
  return (
    <Box
      border="1px solid"
      borderColor="gray.200"
      borderRadius="md"
      p={3}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
      w="100%"
    >
      <Icon width={8} height={8} as={LuMonitorX} color="red.600" />
      <Text fontSize="lg" color="text.fg" fontWeight={600}>Something went wrong</Text>
      <Text fontSize="sm" color="gray.600">The agent failed to complete this step. Please check the execution log for details</Text>
    </Box>
  );
};

export default ErrorView;